import styled from 'styled-components'

export const MainContainer = styled.div`
  padding: 20px;
  width: 85vw;
`;

export const Header = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : space-between;
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const FormBody = styled.div`
  width: 70%; 
  padding: 20px; 
  background-color: white;
  border-radius: 7px;
`
